import { UserContextProjectMetadata } from 'core/userContext';
import { Project } from 'modules/dataWarehouse/types';
import { SMART_INGEST_METRICS } from '../constants';
import { MetricsByProjectId } from '../types';
import { OrgProjectMetric } from 'modules/domains/billing';

const { productionSyncsCount, testSyncsCount } = SMART_INGEST_METRICS;

/**
 * Get a project name from user context with a project id
 */
export const getProjectName = (projects: UserContextProjectMetadata[], projectId: number) => {
  return projects.find((project) => project.id === projectId)?.name || '';
};

/**
 * Format Smart Ingest data so that it better matches Metric type
 */
export const createHightouchMetricsByProjectId = (
  projects: Project[],
  userContextProjects: UserContextProjectMetadata[],
): MetricsByProjectId => {
  return projects.reduce((acc, project) => {
    const currentProject = {
      id: project.id,
      createdAt: '',
      name: getProjectName(userContextProjects, project.id),
      isSandBox: false,
      isArchived: false,
    };

    const testSyncMetric = {
      metricName: SMART_INGEST_METRICS.testSyncsCount,
      value: project.isBillable ? '-' : project.syncsCount,
      project: currentProject,
    };
    const productionSyncMetric = {
      metricName: SMART_INGEST_METRICS.productionSyncsCount,
      value: project.isBillable ? project.syncsCount : '-',
      project: currentProject,
    };

    return { [project.id]: [testSyncMetric, productionSyncMetric], ...acc };
  }, {});
};

export const createSmartIngestOrgMetricsByName = (productionCount: number, testCount: number) => ({
  [productionSyncsCount]: {
    metricName: productionSyncsCount,
    value: productionCount,
  },
  [testSyncsCount]: {
    metricName: testSyncsCount,
    value: testCount,
  },
});

type SmartIngestMetrics = {
  [projectId: string]: OrgProjectMetric[];
};

export const createSmartIngestMetrics = (projects: Project[]): SmartIngestMetrics => {
  return projects.reduce((acc, curr) => {
    const prodMetric = {
      metricName: productionSyncsCount,
      projectId: curr.id,
      value: curr.isBillable ? curr.syncsCount : 0,
    };

    const testMetric = {
      metricName: testSyncsCount,
      projectId: curr.id,
      value: !curr.isBillable ? curr.syncsCount : 0,
    };
    return { ...acc, [curr.id]: [prodMetric, testMetric] };
  }, {});
};
